<template>
  <div class="one">
    <!-- 已知范例 -->
    <span class="page-component__scroll"
          style="font-size:38px">不规则星系</span>
    <p> 不规则星系是一类形状不规则的星系，它们通常缺乏对称性和明确的旋转结构。这些星系可能经历了一系列的天体物理过程，如星系合并或潮汐相互作用，导致它们的形状变得复杂和不规则。</p>
    <div>
      <img class="img"
           src="../assets/img/5.jpg"
           alt="">
    </div>

    <div class="two">
      <span style="font-size:38px">合并星系</span>
      <p> 合并星系是两个或多个星系相互靠近并发生合并过程的结果。这种过程可能导致新的星系形成，同时也可能引发恒星爆炸和高能天文现象。</p>
      <div>
        <img class="img"
             src="../assets/img/6.jpg"
             alt="">
      </div>
    </div>

    <div class="three">
      <span style="font-size:38px">强引力透镜</span>
      <p> 强引力透镜是一种引力作用下的光学现象，通常由质量较大的物体（如星系或黑洞）引起。当光线穿过强引力场时，会发生透镜效应，导致光线的弯曲和多重成像，这可用于研究遥远天体。</p>
      <div>
        <img class="img"
             src="../assets/img/7.jpg"
             alt="">
      </div>
    </div>

    <div class="four">
      <span style="font-size:38px">低表面亮度星系</span>
      <p> 低表面亮度星系是一类表面亮度非常低、光度分布非常稀疏的星系。它们的形态呈现出非常模糊的结构，通常需要深度观测和图像处理才能揭示它们的特征。</p>
      <div>
        <img class="img"
             src="../assets/img/8.jpg"
             alt="">
      </div>
    </div>

    <div class="five">
      <span style="font-size:38px">致密星系</span>
      <p>致密星系是一类具有高密度星际物质和恒星分布的星系。它们通常包含大量恒星，并且星际介质之间的距离较小。这类星系的表面亮度很高，在照相底片上成像很小，刚好能与恒星的像相区别。</p>
      <div>
        <img class="img"
             src="../assets/img/9.jpg"
             alt="">
      </div>
    </div>

    <!-- 回到顶部 -->
    <el-backtop :visibility-height="50"
                :bottom="120">
    </el-backtop>

  </div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
.one {
  color: rgb(44, 62, 80);
  h4 {
    margin-top: 20px;
    font-size: 16px;
  }
  p {
    margin-top: 10px;
    text-indent: 2em;
    line-height: 30px;
    text-align: justify; /*实现两端对齐*/
    font-size: 16px;
  }
  img {
    width: calc(100% - 100px);
    height: auto;
    position: relative;
    left: 50px;
    top: 10px;
  }
  .two {
    margin-top: 20px;
  }
  .three {
    margin-top: 20px;
  }
  .four {
    margin-top: 20px;
  }
  .five {
    margin-top: 20px;
  }
}
</style>